import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAsync } from '../../../../components/helper/axiosHelper';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../../shared/Helper';

const PhotoGalleryDetail = () => {
  const [apiData, setApiData] = useState([]);
  const { id } = useParams();
  const { t } = useTranslation();

  const { pathname } = useLocation();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  const getData = async () => {
    await getAsync('CMSPhotoGallery/GetByIdCMSPhotoGallery/', { id: id })
      .then((response) => {
        const result = response?.data;
        setApiData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="col-lg-12 ">
        <div className="header-wrapper" style={ { textAlign: 'center' } }>
          <h1>Photo Gallery Detail</h1>
        </div>
        <div style={ { margin: '20px', padding: '20px' } } className="col-lg-10">
          { apiData?.map((item, index) => (
            <div key={ index }>
              <div className="wrapper">
                <a href={ item?.link }>
                  <img
                    style={ {
                      borderRadius: '20px',
                      border: '1px solid black',
                      height: '500px',
                      width: '600px',
                    } }
                    src={ `data:image/jpeg;base64,${item?.doc}` }
                    alt="img.jpg"
                  />
                </a>
              </div>
              <div className="content-title">
                <h2>{ item?.title }</h2>
                <a href={ item?.link } target="_blank" rel="noopener noreferrer">
                  { item?.link }
                </a>
                <p>{ item?.publicationDate }</p>
                <p>{ item?.content }</p>
              </div>
              <div className="content">
                <pre>{ item?.filmingLocation ? item?.filmingLocation : 'N/A' }</pre>
              </div>
            </div>
          )) }
        </div>
      </div>
    </>
  );
};

export default PhotoGalleryDetail;
